import StarSolidSVG from "@design-system/ui-icons/vanilla/StarSolid"
import { createIcon } from "../createIcon"

export const StarSolidIcon = createIcon(StarSolidSVG)
